/**
 * What a linked-work picker says when it has no rows to show.
 *
 * Only one of these states is a positive claim that the user has no matching work. The others mean
 * "we do not know yet", and saying "nothing found" in them is a false statement about someone's
 * integration. Shared by both pickers so the wording and the ordering cannot drift.
 */
export const BROWSE_FAILED_LABEL = 'Failed to load linked work. Please try again.';

interface LinkedWorkEmptyStateArgs {
  /** The browse request failed. */
  hasError: boolean;
  /** A request is in flight, or none has settled yet, so nothing can be concluded. */
  isResolving: boolean;
  /** Copy for the authoritative case. The two pickers word this differently. */
  emptyLabel: string;
}

/** Ordered by how much is actually known; only the last arm claims the scope is empty. */
export const resolveLinkedWorkEmptyLabel = ({
  hasError,
  isResolving,
  emptyLabel,
}: LinkedWorkEmptyStateArgs): string => {
  if (hasError) return BROWSE_FAILED_LABEL;
  if (isResolving) return 'Searching...';
  return emptyLabel;
};
